import { useState } from "react";
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import { addBackground } from "../../../../../actions/appsMoreAction";
import { toast } from "react-toastify";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import CheckBoxField from "../../Feeds/AddFeeds/Elements/CheckboxField";
import ColorPicker from "../../../../CommonComponents/ColorPicker";
import { resturctureCloudPath } from "../../../../../utils";
import { UPLOAD_URL } from "../../../../../actions/api";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";


const Background = (props) => {

  const { background, themeBackground, wallData, wall, onUpload } = props;
  const { transparent, color, image } = background;

  const Personalization = wallData.wall.Personalization;
  const ThemeRule = wallData.wall.Personalization.ThemeRule;
  const transparentBg = transparent ? false : true;

  const selected = image ? resturctureCloudPath(image) : "";
  const [removeBg, setremoveBg] = useState(false);
  const [loading, setLoading] = useState(false);

  const onApplyBackground = () => {
    const backgroundObj = {
      isCollaborator: localStorage.getItem("isCollaborator"),
      id: Personalization.id,
      transparent: transparent ? 1 : 0,
      backgroundColor: color,
      backgroundRemove: selected.length ? 0 : 1,
      themeId: ThemeRule.id,
      ownerId: localStorage.getItem("ownerId"),
      picture: selected ? selected : "",
      isPictureChanged: !transparent ? selected || removeBg ? 1 : 0 : 0,
    };

    setLoading(true);
    addBackground(backgroundObj, Personalization.wallId).then((res) => {
      if (res.status) {
        const { responseData } = res.data;
          //DeleteKeys();
          toast.success("Color and Images updated successfully.");
          props.activeSetting(0);
          
          if(responseData && responseData.length > 0){
            const wallBackground = responseData[0].wallBackground;
            props.updateImages('background', { bgImage: wallBackground });
          }
           
          // dispatch(refreshThemes());
          // closePricingModal(dispatch);
      } else {
        toast.error("error");
      }

      setLoading(false);
    });
  };

  const applyChanges = (status) => {
    const { showDiscardPop} = props;
    showDiscardPop(onApplyBackground, 'background', status); 
}

  return (
    <>
      <div className="noLoader overflow-list">
        <div style={{ display: "none" }}>
          <input type="hidden" name="_method" value="POST" />
        </div>
        <div className="pb-3">
          <label className="card-label font-weight-bolder text-dark">Background</label>
        </div>
        <div className="">
          <div className="form-group">
            <div className="d-flex flex-wrap w-100">
              <div className="col-md-9">
                <label className="control-label mb-0">Enable Background </label>
              </div>
              <div className="col-md-3 p-0">
                <div className="toggleOnBut float-end">
                  <span className="switch">
                    <label>
                      <CheckBoxField isChecked={transparentBg} onChangeHandler={(e) => themeBackground({ image: selected, transparent: !e.target.checked ? 1 : 0 })} name={`transparent`} id={`walltransparent`} text={0} />
                    </label>
                  </span>
                </div>
              </div>
            </div>
          </div>

          {transparentBg ? (
            <div className="backgroundOptions color-popup form-group position-relative">
              <label className="control-label mb-2">Background Color  </label>
              <ColorPicker id='bgColor' defaultColor={color} changeColor={(clr) => themeBackground({ color: clr })} />
            </div>
          ) : null}

        </div>

        {transparentBg && ![74, 75, 76, 77].includes(ThemeRule.themeId) ? (

          !selected ?
            <div className="form-group backgroundOptions uppy-uploader">
              <label className="clearfix control-label">Upload Background Image </label>
              {/* <PopupUpload uploadFile={themeBackgroundChange} onUpload={onUpload} setonUpload={setonUpload} /> */}
              <div className="attach-file">
                <button onClick={() => onUpload(true, 'background')} type="button" className="btn btn-outline-secondary d-flex align-items-center justify-content-center w-100">
                  <FontAwesomeIcon type={'solid'} icon={'arrow-up-from-bracket'} iconClass={'fs-5 me-2'} />
                  Attach file
                </button>
              </div>
            </div>

            :

            <div className="p-0 ">
              <div
                className="image-input fileinput fileinput-new addProUploder addbgUpload uppy_upload ms-0"
                data-provides="fileinput"
                style={{ display: "flex" }}>
                <div
                  id="BannerBackgroundImageUpload"
                  style={{ backgroundImage: `url('${resturctureCloudPath(selected, UPLOAD_URL)}')` }}
                  className="BannerBackgroundImageUpload align-content-center flex-wrap justify-content-center mb-0 border-bottom-0"
                  data-trigger="fileinput"
                >
                  <input type="hidden" id="BbannerBack" />
                  <button
                    type="button"
                    id="removeBgBanner"
                    className="removeBgBanner btn btn-xs btn-icon btn-circle btn-white btn-shadow"
                    onClick={() => { onUpload(false, 'background'); setremoveBg(true); themeBackground({ image: '' }) }}
                  >
                    <i className="fa fa-close"></i>
                  </button>
                </div>
                <div className="drop-box" id="kt_uppy_4">
                  <div className="uppy-dashboard"></div>
                  <div className="uppy-progress"></div>
                </div>
              </div>
            </div>

        ) : null}

        {transparentBg && ![74, 75, 76, 77].includes(ThemeRule.themeId) ? (
          <div className="pt-0">
            <div className="aspectRatios">1920 x 1080 Image with Aspect Ratio and Resolution of Intended Display.</div>
          </div>
        ) : null}
      </div>
      <div className="form-actions px-3 pt-3">
        <div className="card-toolbar f-center">
          <Button variant="secondary" onClick={()=>applyChanges(0)} type="button" className="me-2 w-50"> Back</Button>
          <Button variant="dark" disabled={loading}
            className={`${loading
                ? "ladda-button spinner spinner-white spinner-right disabled "
                : ""
              }me-2 w-50`}
              onClick={()=>applyChanges(1)}
          >
            Save
          </Button>


          <OverlayTrigger placement="top" overlay={<Tooltip>Help</Tooltip>}>
            <a
              className="lity_lightbox"
              href="https://vimeo.com/545382711/aa0432f118"
              data-support="https://taggbox.com/support/how-to-change-background-for-your-social-media-widget/"
              data-lity
            >
              <FontAwesomeIcon type={'regular'} icon={'circle-question'} iconClass={''} />
            </a>
          </OverlayTrigger>
        </div>
      </div>
    </>


  );
};

export default Background;
